<template>
  <div>
    <div class="steps_body">
      <app-page-section>
        <template #title>
          {{ $t("Neve") }}
          <app-tooltip class="m-width-m">
            {{ $t("Valor característico das acções da neve") }}
          </app-tooltip>
        </template>

        <template #controls>
          <calc-phis-controls the-case="snow" />
        </template>

        <calc-form-card-generic-load-cfg
          :item-title="$t('Carga')"
          the-case="snow"
          the-type="regular"
        />

        <calc-form-card-generic-load-cfg
          :title="$t('Carga excepcional')"
          :optional="true"
          v-model="calculation.input.internal.loads.snowExceptional"
          :item-title="$t('Carga')"
          the-case="snow"
          the-type="exceptional"
        />

        <calc-form-card
          :title="$t('Acumulação de neve')"
          :optional="true"
          v-model="calculation.input.internal.loads.snowAccumulation"
        >
          <calc-form-item-snow-accumulation />

          <template slot="illustration">
            <calc-illustration which="snowAccumulation" position="absolute" />
          </template>
        </calc-form-card>
      </app-page-section>
    </div>

    <div class="steps_nav">
      <b-button
        class="steps_nav__btn"
        @click="$emit('prev')"
        icon-left="arrow-left"
        size="is-medium"
        type="is-primary"
        inverted
        >{{ $t("Voltar") }}</b-button
      >
      <b-button
        class="steps_nav__btn"
        @click="$emit('next')"
        icon-right="arrow-right"
        size="is-medium"
        type="is-primary"
        >{{ $t("Continuar") }}</b-button
      >
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import CalcFormCardGenericLoadCfg from "./CalcFormCardGenericLoadCfg";
import CalcFormItemSnowAccumulation from "./CalcFormItemSnowAccumulation";
import CalcPhisControls from "./CalcPhisControls";
import CalcIllustration from "./CalcIllustration";

export default {
  name: "CalcStepSnow",

  components: {
    CalcFormCardGenericLoadCfg,
    CalcFormItemSnowAccumulation,
    CalcPhisControls,
    CalcIllustration,
  },

  computed: {
    ...mapState("calculator", ["calculation"]),
    ...mapGetters("calculator", ["load"]),

    classNames() {
      return [this.calculation.input.type === 2 ? "is-inactive" : ""];
    },

    snowAccumulationLoad() {
      return this.load("snow", "accumulation");
    },
  },

  watch: {
    "calculation.input.internal.loads.snowAccumulation"(val) {
      if (!val) {
        this.resetSnowAccumulationLoad();
      }
    },
  },

  methods: {
    resetSnowAccumulationLoad() {
      this.snowAccumulationLoad.value = [
        [0, 0],
        [0, 0],
        [0, 0],
      ];
    },
  },
};
</script>

<style lang="scss">
.step_component {
  $root: &;

  position: relative;

  &__not_required_text {
    display: none;
    font-family: $font-family-title;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 500;
    color: #222;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  //state
  &.is-inactive {
    #{$root}__content {
      opacity: 0.15;
    }

    #{$root}__not_required_text {
      display: block;
    }
  }
}
</style>
